import { capitalizeFirstLetter as i } from "../../../helpers/text-helper.js";
import "react/jsx-runtime";
import "dayjs";
const o = (t) => {
  const e = t.alias ?? t.freeText ?? t.title;
  return {
    id: t.trailerTypeId,
    image: {
      url: t.image,
      alt: t.title
    },
    title: i(e),
    maxLoad: t.maxLoad,
    totalWeight: t.totalWeight,
    fromPrice: t.fromPrice,
    measurements: {
      height: t.height,
      width: t.width,
      length: t.length
    }
  };
}, n = (t) => ({
  ...o(t.trailer),
  stationName: t.stationName,
  distanceInMeters: t.distanceInMeters
});
export {
  n as mapNearbyTrailerToTrailer,
  o as mapResponseTrailerToTrailer
};
